/**
 * Application route constants
 */

export const ROUTES = {
  HOME: "/",
  ECOSYSTEM: "/ecosystem",
  AI_ENGINE: "/ai-engine",
  TOKENOMICS: "/tokenomics",
  TRACTION: "/traction",
  ABOUT_US: "/about-us",
  ELEVATE_TO_ALPHA: "/elevate-to-alpha",
  OUR_TEAM: "/our-team",
  USER_JOURNEYS: "/user-journeys",
  REGULATORY_COMPLIANCE: "/regulatory-compliance",
  SOCIAL_IMPACT_COLLECTIVE: "/social-impact-collective",
  IGAC: "/integrity-gated-ambassador-channel",
  ROADMAP: "/roadmap",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  DOCUMENTATION: "/documentation",
  WHITEPAPER: "/whitepaper",
  TOKEN_ECONOMICS_DOWNLOAD: "/token-economics",
  COMPLIANCE_HUB: "/compliance-hub",
  SECURITY: "/security",
  BLOG: "/blog",
  BLOG_LAYERZERO_OFT: "/blog/layerzero-oft-explained",
  BLOG_BEYOND_THE_AUDIT_CONTINUOUS_SECURITY_VALIDATION:
    "/blog/beyond-the-audit-continuous-security-validation",
  BLOG_BLOCKCHAIN_ANALYTICS: "/blog/blockchain-analytics-investor-protection",
  BLOG_BRIDGES_ATTACK_SURFACE: "/blog/bridges-attack-surface",
  BLOG_BUG_BOUNTIES: "/blog/bug-bounties-responsible-disclosure",
  BLOG_COMPLIANCE_FIRST: "/blog/compliance-first-architecture",
  BLOG_SECURITY_BY_DESIGN: "/blog/security-by-design-not-slogan",
  BLOG_OFT_VS_WRAPPED: "/blog/oft-vs-wrapped-tokens",
  BLOG_SUPPLY_INTEGRITY: "/blog/supply-integrity-across-chains",
  BLOG_TOKENOMICS_VERIFY: "/blog/tokenomics-you-can-verify",
  BLOG_CROSS_CHAIN_IDENTITY: "/blog/cross-chain-identity-reputation",
  BLOG_CROSS_CHAIN_BRIDGES_OFT: "/blog/cross-chain-bridges-oft-messaging",
  BLOG_INCIDENT_RESPONSE_OMNICHAIN: "/blog/incident-response-omnichain-systems",
  BLOG_INSTITUTIONAL_GRADE_SECURITY: "/blog/institutional-grade-security",
  BLOG_BRIDGE_UX_SECURITY: "/blog/bridge-ux-security-checklist",
  BLOG_SMART_CONTRACT_AUDITS: "/blog/smart-contract-audits-explained",
  BLOG_MONITORING_THREAT_DETECTION: "/blog/monitoring-threat-detection",
  BLOG_SECURE_KEY_MANAGEMENT: "/blog/secure-key-management",
  BLOG_TWO_FACTOR_AUTHENTICATION: "/blog/2fa-crypto-accounts",
  BLOG_END_TO_END_ENCRYPTION: "/blog/end-to-end-encryption-fintech",
  BLOG_ENFORCING_ACCOUNTABILITY_POST_LAUNCH_GOVERNANCE_OVERSIGHT:
    "/blog/enforcing-accountability-post-launch-governance-oversight-investor-protection",
  BLOG_EMERGENCY_WITHDRAWALS_CIRCUIT_BREAKERS:
    "/blog/emergency-withdrawals-circuit-breakers",
  BLOG_RUG_PULLS_LAUNCH_SCAMS: "/blog/rug-pulls-launch-scams",
  BLOG_AI_BLOCKCHAIN_SECURITY: "/blog/ai-blockchain-security",
  BLOG_ALPHA_AI_ENGINE: "/blog/alpha-ai-engine-intelligent-matching",
  BLOG_ELEVATE_TO_ALPHA: "/blog/elevate-to-alpha-community-incentives-framework",
  BLOG_ALPHA_SHOWCASES: "/blog/alpha-showcases-milestone-linked-presentation-pages",
  BLOG_ALPHA_SHORTLISTS: "/blog/alpha-shortlists-collaborative-curation",
  BLOG_PROOF_OF_EXECUTION: "/blog/proof-of-execution-verifiable-reputation",
  BLOG_TALENT_MARKETPLACE_ESCROW:
    "/blog/talent-marketplace-escrow-secure-service-delivery",
  BLOG_LIQUIDITY_PLANNING_TOOLS: "/blog/liquidity-planning-tools-dex-cex-allocation",
  BLOG_MARKET_MAKER_INVENTORY_UNLOCKS:
    "/blog/market-maker-inventory-unlocks-50-25-25-model",
  BLOG_DEX_LISTING_READINESS: "/blog/dex-listing-readiness-liquidity-commitment-lock-ins",
  BLOG_UTILITY_BOUND_TOKENS_101: "/blog/utility-bound-tokens-ubts-101",
  BLOG_DISCLOSURE_DISCIPLINE: "/blog/disclosure-discipline-supply-emissions-liquidity",
  BLOG_STAKING_ANALYTICS_DASHBOARD: "/blog/staking-analytics-dashboard",
  BLOG_MEASURING_UTILITY: "/blog/measuring-utility-metrics",
  BLOG_LIQUIDITY_CONTROLS_101: "/blog/liquidity-controls-101",
  BLOG_ALLOCATION_BANDS_EXPLAINED: "/blog/allocation-bands-explained",
  BLOG_TRANSPARENT_ORDER_BOOKS: "/blog/transparent-order-books-price-discovery",
  BLOG_UNLOCKS_CLIFFS_LINEAR_VESTING: "/blog/unlocks-cliffs-linear-vesting",
  BLOG_THIRTY_MONTH_EMISSIONS_PLAN: "/blog/30-month-emissions-plan",
  BLOG_TRANSPARENCY_STACK: "/blog/transparency-stack-dashboards-reporting",
  BLOG_GOVERNANCE_APPROVED_PARAMETER_CHANGES:
    "/blog/governance-approved-parameter-changes",
  BLOG_READINESS_GATES_DISCLOSURES: "/blog/readiness-gates-disclosures",
  BLOG_VALUE_ACCRUAL_ENGINE: "/blog/value-accrual-engine-dpcf",
  BLOG_BUYBACK_BURN_VS_ALLOCATE: "/blog/buyback-burn-vs-allocate",
  BLOG_SINGLE_SIDED_VS_LP_STAKING: "/blog/single-sided-vs-lp-staking",
  BLOG_NON_CASHABLE_REWARDS: "/blog/non-cashable-rewards-compliance",
  BLOG_AML_CTF_COMPLIANCE: "/blog/aml-ctf-compliance-safety",
  BLOG_GOVERNANCE_RISKS_OMNICHAIN: "/blog/governance-risks-omnichain",
  BLOG_GUARDIANS_OF_CROSS_CHAIN_INTEGRITY: "/blog/guardians-of-cross-chain-integrity",
  BLOG_FAST_BRIDGES_SYSTEMIC_RISK: "/blog/fast-bridges-systemic-risk",
  BLOG_FROM_WALL_STREET_TO_WEB3:
    "/blog/from-wall-street-to-web3-adapting-traditional-risk-controls",
  BLOG_REPLAY_ATTACKS_REORG_RISK: "/blog/replay-attacks-reorg-risk",
  BLOG_RESILIENCE_AS_A_SERVICE: "/blog/resilience-as-a-service",
  BLOG_RUG_PULL_DETECTION: "/blog/rug-pull-detection",
  BLOG_MEV_FRONT_RUNNING: "/blog/mev-front-running",
  BLOG_CRYPTO_REGULATION_TRENDS_2026: "/blog/crypto-regulation-trends-2026",
  BLOG_DYNAMIC_COMPLIANCE:
    "/blog/dynamic-compliance-adapting-to-regulatory-change-in-a-cross-chain-platform",
  BLOG_CHOOSE_TRUSTED_LAUNCHPAD: "/blog/how-to-choose-trusted-launchpad",
  BLOG_USER_PRIVACY_COMPLIANCE: "/blog/user-privacy-vs-compliance",
  BLOG_SECURITY_METRICS: "/blog/security-metrics-every-platform",
  BLOG_SECURITY_CULTURE: "/blog/security-culture-product-feature",
  BLOG_SIMULATING_THE_LAUNCH:
    "/blog/simulating-the-launch-how-we-test-and-tune-operations-before-go-live",
  BLOG_STAKING_AND_SECURITY: "/blog/staking-and-security",
  BLOG_TRUST_STACK:
    "/blog/the-trust-stack-combining-code-compliance-and-community-to-secure-web3-investments",
  BLOG_ON_CHAIN_MONITORING: "/blog/on-chain-monitoring-101",
  BLOG_ZERO_KNOWLEDGE_KYC: "/blog/zero-knowledge-kyc",
  BLOG_ANONYMOUS_CROSS_CHAIN_REPUTATION: "/blog/anonymous-cross-chain-reputation",
  BLOG_PRIVACY_PRESERVING_COMPLIANCE: "/blog/privacy-preserving-compliance",
  BLOG_GOVERNANCE_PARTICIPATION_WITHOUT_IDENTITY:
    "/blog/governance-participation-without-identity",
  BLOG_CROSS_CHAIN_CREDENTIAL_SYSTEMS: "/blog/cross-chain-credential-systems",
  BLOG_PSEUDONYMOUS_VETTING: "/blog/pseudonymous-vetting",
  BLOG_LEGAL_COMPLIANCE_FRAMEWORKS_ANONYMOUS_WEB3:
    "/blog/legal-compliance-frameworks-anonymous-web3",
  BLOG_REPUTATION_PORTABILITY_ACROSS_CHAINS: "/blog/reputation-portability-across-chains",
  BLOG_ZERO_KNOWLEDGE_PROOFS_REGULATORY_COMPLIANCE:
    "/blog/zero-knowledge-proofs-regulatory-compliance",
  BLOG_ANONYMOUS_STAKING_AND_GOVERNANCE: "/blog/anonymous-staking-and-governance",
  BLOG_MULTI_SITE_ECOSYSTEM_ARCHITECTURE: "/blog/multi-site-ecosystem-architecture",
  BLOG_WEB3_WALLET_AUTHENTICATION: "/blog/web3-wallet-authentication",
  BLOG_VENTURE_ONBOARDING_READINESS_VERIFICATION:
    "/blog/venture-onboarding-readiness-verification",
  BLOG_TOKEN_DESIGN_TOOLS_VESTING_SCHEDULERS:
    "/blog/token-design-tools-vesting-schedulers",
  BLOG_POST_LAUNCH_OPERATING_CONSOLE: "/blog/post-launch-operating-console",
  BLOG_CROSS_CHAIN_VESTING: "/blog/cross-chain-vesting",
  BLOG_COMPLIANCE_AWARE_LAUNCH_WORKFLOWS: "/blog/compliance-aware-launch-workflows",
  BLOG_LAUNCHPAD_MILESTONE_MANAGEMENT: "/blog/launchpad-milestone-management",
  BLOG_ADMIN_DASHBOARD_AND_ANALYTICS: "/blog/admin-dashboard-and-analytics",
  BLOG_COMPREHENSIVE_AUDIT_LOGGING: "/blog/comprehensive-audit-logging",
  BLOG_INFLUENCER_CREATOR_PLATFORM: "/blog/influencer-creator-platform",
  BLOG_PROFESSIONAL_NETWORKING_WEB3: "/blog/professional-networking-web3",
  BLOG_PROFILE_MANAGEMENT_IDENTITY: "/blog/profile-management-identity",
  BLOG_CAIP_STANDARDS_CROSS_CHAIN_IDENTITY: "/blog/caip-standards-cross-chain-identity",
  BLOG_NON_CUSTODIAL_MARKETPLACE_ARCHITECTURE:
    "/blog/non-custodial-marketplace-architecture",
  CAREERS: "/careers",
  PRESS_KIT: "/press-kit",
  ACCEPTABLE_USE_POLICY: "/acceptable-use-policy",
  RISK_DISCLOSURE_POLICY: "/risk-disclosure-policy",
  DATA_ROOM_ACCESS_POLICY: "/data-room-access-policy",
  ADVERTISING_POLICY: "/advertising-policy",
  COOKIE_POLICY: "/cookie-policy",
  REFUND_AND_RETURN_POLICY: "/refund-and-return-policy",
  DISPUTE_RESOLUTION_POLICY: "/dispute-resolution-policy",
  ACCESSIBILITY_POLICY: "/accessibility-policy",
  DATA_BREACH_NOTIFICATION_POLICY: "/data-breach-notification-policy",
  COMMUNITY_GUIDELINES: "/community-guidelines",
  COPYRIGHT_DMCA_POLICY: "/copyright-dmca-policy",
  CONTENT_MODERATION_APPEALS_POLICY: "/content-moderation-appeals-policy",
  KYC_AML_SANCTIONS_POLICY: "/kyc-aml-sanctions-policy",
  SECURITY_VULNERABILITY_DISCLOSURE_POLICY: "/security-vulnerability-disclosure-policy",
  DAO_GOVERNANCE_TRANSPARENCY_POLICY: "/dao-governance-transparency-policy",
  COMPLAINTS_CONSUMER_RIGHTS_POLICY: "/complaints-consumer-rights-policy",
  EU_UK_GDPR_PRIVACY_NOTICE: "/eu-uk-gdpr-privacy-notice",
  CALIFORNIA_PRIVACY_NOTICE: "/california-privacy-notice",
  ALPHA_TOKEN_TERMS: "/alpha-token-terms",
  LEGAL: "/legal",
  CONTACT: "/contact",
  WAITLIST: "/waitlist",
  FAQ: "/faq",
  // Legacy routes from old website
  OUR_VISION: "/our-vision",
  RISK_MITIGATION_STRATEGY: "/risk-mitigation-strategy",
  INTEGRATED_SECURITY_PROTOCOL: "/integrated-security-protocol",
  // Legacy route aliases
  OUR_ECOSYSTEM: "/our-ecosystem",
  OUR_TOKENOMICS: "/our-tokenomics",
  OUR_TRACTION: "/our-traction",
  OUR_ROADMAP: "/our-roadmap",
  WHITE_PAPER: "/white-paper",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
